import { render, staticRenderFns } from "./CVSPreview.vue?vue&type=template&id=b3052894&"
import script from "./CVSPreview.vue?vue&type=script&lang=js&"
export * from "./CVSPreview.vue?vue&type=script&lang=js&"
import style0 from "./CVSPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports